// import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

// project imports
import CustomerRoutes from './CustomerRoutes';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import RestaurantRoutes from './RestaurantRoutes';
// import ComponentsRoutes from './ComponentsRoutes';
import RoleBasedRedirect from 'components/RoleBasedRedirect';
import AdminRoutes from './AdminRoutes';
import WaiterRoutes from './WaiterRoutes';
import ReviewRedirect from 'components/ReviewRedirect';
import WorkerInviteRedirect, { RedirectPath } from 'components/WorkerInviteRedirect';
import { lazy } from 'react';
import Loadable from 'components/Loadable';
import SelectWaiterRedirect from 'components/SelectWaiterRedirect';

const RateReservation = Loadable(lazy(() => import('pages/my-reservation/rate-waiter')));
const GeneralQrFeedback = Loadable(lazy(() => import('pages/my-reservation/general-qr-feedback')));
const RateReservationConfirmed = Loadable(lazy(() => import('pages/my-reservation/rate-waiter-confirmed')));

// ==============================|| ROUTING RENDER ||============================== //

const ReviewRedirects = [
  {
    path: '/qr/:id',
    element: <ReviewRedirect />
  },
  {
    path: '/redirect/worker-invited-by-a-restaurant',
    element: <WorkerInviteRedirect loginWithEmail redirectPath={RedirectPath.SET_PASSWORD} />
  },
  {
    path: '/redirect/customer-reminder-to-leave-feedback',
    element: <WorkerInviteRedirect redirectPath={RedirectPath.FEEDBACK} />
  },
  {
    path: '/redirect/customer-schedule-available',
    element: <SelectWaiterRedirect />
  },
  {
    path: '/redirect/worker-availability-request',
    element: <WorkerInviteRedirect loginWithEmail redirectPath={RedirectPath.MY_REQUESTS} />
  },
  {
    path: '/redirect/manager-invite',
    element: <WorkerInviteRedirect loginWithEmail redirectPath={RedirectPath.SET_PASSWORD} />
  },
  {
    path: '/redirect/reset-password',
    element: <WorkerInviteRedirect redirectPath={RedirectPath.SET_PASSWORD} />
  }
];

const OpenedRoutes = [
  {
    path: '/feedback/general',
    element: <GeneralQrFeedback />
  },
  {
    path: '/feedback/:waiterId',
    element: <RateReservation />
  },
  {
    // query params: stars, comment, avatar_url, isNoLogin
    path: '/feedback/confirmed/:waiterId',
    element: <RateReservationConfirmed />
  }
];

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <RoleBasedRedirect allowedRoles={['admin', 'manager']} />
    },
    // {
    //   path: '/landing',
    //   element: <SimpleLayout layout={SimpleLayoutType.LANDING} />,
    //   children: [
    //     {
    //       index: true,
    //       element: <PagesLanding />
    //     }
    //   ]
    // },
    LoginRoutes,
    CustomerRoutes,
    RestaurantRoutes,
    WaiterRoutes,
    AdminRoutes,
    // ComponentsRoutes,
    MainRoutes,

    ...OpenedRoutes,
    ...ReviewRedirects
  ],
  { basename: import.meta.env.VITE_APP_BASE_NAME }
);

export default router;
